import { useRouter } from 'next/router';
import Image from 'next/future/image';
import Link from 'next/link';
import cartAccount from '@/public/icons/account/cart.svg';
import cartAccountFill from '@/public/icons/account/cart-fill.svg';
import homeAccount from '@/public/icons/account/home.svg';
import homeAccountFill from '@/public/icons/account/home-fill.svg';
import wishlist from '@/public/icons/account/wishlist.svg';
import wishlistFill from '@/public/icons/account/wishlist-fill.svg';
import logoutAccount from '@/public/icons/account/logout.svg';
import claimAccount from '@/public/icons/account/claim.svg';
import claimAccountFill from '@/public/icons/account/claim-fill.svg';
import tradeIn from '@/public/icons/account/trade-in.svg';
import settings from '@/settings';
import { useCustomerContext } from '@/lib/customer/CustomerContext';

const STYLES = {
  BASE: 'flex flex-col-reverse justify-between items-center p-3 py-4 w-full text-sm text-center text-gray-700 hover:bg-gray-300  border-b border-gray-200 lg:flex-row lg:text-left xl:px-6 hover:font-bold xl:text-base',
  ACTIVE:
    'flex flex-col-reverse justify-between items-center p-3 py-4 w-full text-sm text-center text-gray-700 bg-gray-300  rounded-t border-b-2 border-gray-700 lg:flex-row lg:text-left lg:border-b lg:border-gray-200 xl:px-6 font-bold xl:text-base',
};

export default function AccountNav() {
  const router = useRouter();
  const { logout } = useCustomerContext();
  const isOrderRoute =
    router.pathname.endsWith('/orders') ||
    router.pathname.endsWith('/return') ||
    router.pathname.endsWith('/warrantyClaim') ||
    router.pathname.endsWith('/help');
  const isAddressRoute = router.pathname.endsWith('/addresses');
  const isClaimRoute = router.pathname.endsWith('/claims');
  const isWishlistRoute = router.pathname.endsWith('/wishlist');
  const isTradeInRoute = router.pathname.endsWith('/trade-in');

  // Add US Store below to enable Claims Page feature in RT-4545 for US Store
  const isUSStore = settings.store === 'reebelo-dev';

  return (
    <div className="fixed bottom-0 left-0 z-30 w-full bg-white shadow-lg lg:static lg:w-2/12 lg:rounded lg:border lg:border-gray-200 lg:shadow-none">
      <div className="flex w-full lg:block">
        <Link href={'/account/orders'}>
          <a className={isOrderRoute ? STYLES.ACTIVE : STYLES.BASE}>
            <span>
              <span className="hidden lg:inline-block">My</span> Orders
            </span>
            <div className="mb-2 h-5 w-5 lg:mb-0 lg:h-4 lg:w-4 xl:h-5 xl:w-5">
              <Image
                height={20}
                width={20}
                alt="cartAccount"
                src={isOrderRoute ? cartAccountFill : cartAccount}
              />
            </div>
          </a>
        </Link>
        {settings.store === 'reebelo-us' && (
          <Link href={'/account/trade-in'}>
            <a className={isTradeInRoute ? STYLES.ACTIVE : STYLES.BASE}>
              <span>
                <span className="hidden lg:inline-block">My</span> Trade In
              </span>
              <div className="mb-2 h-5 w-5 lg:mb-0 lg:h-4 lg:w-4 xl:h-5 xl:w-5">
                <Image height={20} width={20} alt="cartAccount" src={tradeIn} />
              </div>
            </a>
          </Link>
        )}
        <Link href={'/account/addresses'}>
          <a className={isAddressRoute ? STYLES.ACTIVE : STYLES.BASE}>
            <span>
              <span className="hidden lg:inline-block">My</span> Addresses
            </span>
            <div className="mb-2 h-5 w-5 lg:mb-0 lg:h-4 lg:w-4 xl:h-5 xl:w-5">
              <Image
                height={18}
                width={18}
                alt="homeAccount"
                src={isAddressRoute ? homeAccountFill : homeAccount}
              />
            </div>
          </a>
        </Link>
        <Link href={'/account/wishlist'}>
          <a className={isWishlistRoute ? STYLES.ACTIVE : STYLES.BASE}>
            <span>
              <span className="hidden lg:inline-block">My</span> Wishlist
            </span>
            <div className="mb-2 h-5 w-5 lg:mb-0 lg:h-4 lg:w-4 xl:h-5 xl:w-5">
              <Image
                height={20}
                width={20}
                alt="wishlistAccount"
                src={isWishlistRoute ? wishlistFill : wishlist}
              />
            </div>
          </a>
        </Link>
        {isUSStore && (
          <Link href={'/account/claims'}>
            <a className={isClaimRoute ? STYLES.ACTIVE : STYLES.BASE}>
              <span>
                <span className="hidden lg:inline-block">My</span> Claims
              </span>
              <div className="mb-2 h-5 w-5 lg:mb-0 lg:h-4 lg:w-4 xl:h-5 xl:w-5">
                <Image
                  height={18}
                  width={18}
                  alt="homeAccount"
                  src={isClaimRoute ? claimAccountFill : claimAccount}
                />
              </div>
            </a>
          </Link>
        )}
        <a
          className={`${STYLES.BASE} cursor-pointer`}
          onClick={async () => logout().then(() => router.push('/'))}
        >
          Logout
          <div className="mb-2 h-5 w-5 lg:mb-0 lg:h-4 lg:w-4 xl:h-5 xl:w-5">
            <Image
              height={20}
              width={20}
              alt="logoutAccount"
              src={logoutAccount}
            />
          </div>
        </a>
      </div>
    </div>
  );
}
